// The URL flag a session-end reload carries (SPEC-095). Kept apart from
// session.js so the route guards and App can use it without an import cycle.
export const SESSION_EXPIRED_PARAM = 'sessionExpired'

// A search string without the session flag (for return-to links).
export const withoutSessionFlag = (search) => {
  const params = new URLSearchParams(search)
  params.delete(SESSION_EXPIRED_PARAM)
  const rest = params.toString()
  return rest ? `?${rest}` : ''
}

// The URL the app booted on, read before the router runs: by the time App's
// effects run, a guard may already have moved the page to /login.
const bootLocation =
  typeof window === 'undefined'
    ? { pathname: '/', search: '', hash: '' }
    : {
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash
      }
export const getBootLocation = () => bootLocation
